import { render, staticRenderFns } from "./edsFileIcon.vue?vue&type=template&id=2aa0c24a"
import script from "./edsFileIcon.vue?vue&type=script&lang=js"
export * from "./edsFileIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports